import type { SiteConfig } from '../../@types/context/site-config.types';

export const contactAxoSeConfig: Pick<SiteConfig, 'contact'> = {
  contact: {
    phone: '0771 323400',
    email: 'kundservice@axofinans.se',
  },
};
